import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Button } from '@/components/ui/button';
import { ScrollArea } from '@/components/ui/scroll-area';
import { GameController, SignOut, Trophy, GearSix } from '@phosphor-icons/react';

export const GamesSidebar = ({ games, selectedGame, onSelectGame, user, onLogout, onViewProfile, onOpenAdmin }) => {
  return (
    <div className="w-80 border-r border-[#E4E4E7] bg-white flex flex-col" data-testid="games-sidebar">
      <div className="p-6 border-b border-[#E4E4E7]">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-3">
            <div className="bg-[#0047FF] p-2">
              <GameController size={24} weight="fill" color="#FFFFFF" />
            </div>
            <h1 className="font-heading text-xl font-bold tracking-tight text-[#09090B]">
              DashLink
            </h1>
          </div>
          {user.is_admin && (
            <Button
              variant="ghost"
              size="icon"
              onClick={onOpenAdmin}
              className="hover:bg-[#F4F4F5] transition-colors"
              data-testid="admin-button"
            >
              <GearSix size={20} weight="regular" />
            </Button>
          )}
        </div>
        
        <div className="flex items-center gap-3 p-3 bg-[#FAFAFA] border border-[#E4E4E7]">
          <button
            onClick={() => onViewProfile(user.id)}
            className="hover:opacity-80 transition-opacity"
            data-testid="sidebar-user-avatar"
          >
            <Avatar className="h-10 w-10 cursor-pointer">
              <AvatarImage src={user.avatar} alt={user.username} />
              <AvatarFallback>{user.username[0]}</AvatarFallback>
            </Avatar>
          </button>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium text-[#09090B] truncate">
              {user.username}
              {user.is_admin && <span className="ml-1 text-xs text-[#0047FF]">(Admin)</span>}
            </p>
            <p className="text-xs font-mono text-[#71717A]">{user.score} pts</p>
          </div>
          <Button
            variant="ghost"
            size="icon"
            onClick={onLogout}
            className="hover:bg-[#F4F4F5] transition-colors"
            data-testid="logout-button"
          >
            <SignOut size={18} weight="regular" />
          </Button>
        </div>
      </div>

      <ScrollArea className="flex-1 scrollbar-hide">
        <div className="p-4">
          <h2 className="text-xs font-medium text-[#71717A] uppercase tracking-wider mb-3 px-2">
            Active Games
          </h2>
          <div className="space-y-1">
            {games.map((game) => (
              <button
                key={game.id}
                onClick={() => onSelectGame(game)}
                className={`w-full p-3 border border-[#E4E4E7] transition-colors text-left ${
                  selectedGame?.id === game.id
                    ? 'bg-[#0047FF] text-white border-[#0047FF]'
                    : 'bg-white hover:bg-[#FAFAFA]'
                }`}
                data-testid={`game-item-${game.id}`}
              >
                <div className="flex items-center gap-3">
                  <img
                    src={game.image}
                    alt={game.name}
                    className="w-12 h-12 object-cover"
                  />
                  <div className="flex-1 min-w-0">
                    <p className={`text-sm font-medium truncate ${
                      selectedGame?.id === game.id ? 'text-white' : 'text-[#09090B]'
                    }`}>
                      {game.name}
                    </p>
                    <div className="flex items-center gap-2 mt-0.5">
                      <span className={`text-xs ${
                        selectedGame?.id === game.id ? 'text-white/80' : 'text-[#71717A]'
                      }`}>
                        {game.genre}
                      </span>
                      <span className={`text-xs font-mono ${
                        selectedGame?.id === game.id ? 'text-white/80' : 'text-[#71717A]'
                      }`}>
                        {game.players.toLocaleString()} online
                      </span>
                    </div>
                  </div>
                </div>
              </button>
            ))}
          </div>
        </div>
      </ScrollArea>
    </div>
  );
};